import React, { useState } from 'react';
import axios from 'axios';
import Sidebar from './Sidebare';
import {
  Box, Typography, Button, Card,
  IconButton, Select, MenuItem,
  Checkbox, FormControlLabel
} from '@mui/material';
import { UploadFile } from '@mui/icons-material';
import './PublicationForm.css';
import { useAuth } from '../contexts/AuthContext';

const MyDocuments = () => {
  const { user } = useAuth();
  const [attachments, setAttachments] = useState([]);
  const [documentType, setDocumentType] = useState('Diplôme du Bac');
  const [validated, setValidated] = useState(user?.canCandidate);

  const handleFileChange = (e) => {
    const newAttachments = Array.from(e.target.files).map(file => ({
      file,
      type: documentType,
      checked: ['Diplôme du Bac', 'Relevé de Notes'].includes(documentType),
      preview: '/uploads/pdf_icon.jpg'
    }));
    setAttachments([...attachments, ...newAttachments]);
  };

  const handleValidation = async () => {
    try {
      const formData = new FormData();
      attachments.forEach(doc => formData.append('attachments', doc.file));
      const token = localStorage.getItem('authToken');

      await axios.post('https://ega-senegal.com/api/candidatures/documents', formData, {
        headers: {
          "Content-Type": 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      setValidated(true);
    } catch (error) {
      console.error('Erreur lors de la validation des documents:', error);
    }
  };

  return validated ? (
    <Box display="flex" height="100vh">
      <Sidebar userProfile={user} />
      <Box flex={1} p={2} display="flex" flexDirection="column" alignItems="center">
        <Card sx={{ maxWidth: 600, p: 2 }}>
          <Typography variant='h6' color="success.main">Félicitations</Typography>
          <Typography variant="body2" align="center" paragraph>
            Vos documents sont validés. Consultez les differents programmes et Postuler jusqu'à 5 programmes.
          </Typography>
        </Card>
      </Box>
    </Box>
  ) : (
    <Box display="flex" height="100vh">
      <Sidebar userProfile={user} />
      <Box flex={1} p={2} display="flex" flexDirection="column" alignItems="center">
        <Card sx={{ maxWidth: 600, p: 2 }}>
          <Typography variant="h6">Type de Document</Typography>
          <Select fullWidth value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
            {['Diplôme du Bac', 'Relevé de Notes', 'Autres'].map(option => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </Select>
          <IconButton component="label" color="primary">
            <UploadFile />
            <input hidden type="file" accept="application/pdf" onChange={handleFileChange} />
          </IconButton>
          <Button variant="contained" color="primary" onClick={handleValidation} disabled={!attachments.some(doc => doc.checked)}>
            Valider vos documents
          </Button>
        </Card>
        {attachments.map((doc, index) => (
          <Card key={index} sx={{ display: 'flex', alignItems: 'center', p: 1, mb: 1 }}>
            <img src={doc.preview} alt="document" style={{ width: 40, height: 40, marginRight: 10 }} />
            <FormControlLabel control={<Checkbox checked={doc.checked} disabled />} label={`${doc.type} inséré`} />
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default MyDocuments;
